<template>
  <tsl-card :cardList="cardIntroduce">
    <template v-slot:introduce>
      <p class="content">
        操作审计（ActionTrail）记录TacOS本地及Cloud的关键操作事件。您可以在线查询90天的操作事件，也可以通过创建跟踪将更长时间的事件保存到自己的账号下的存储空间。基于留存的操作事件，您可以实现历史事件追溯、操作安全分析、敏感操作告警以及应对外部审计。
      </p>
    </template>
  </tsl-card>
  <overview-charts />
</template>

<script>
import Card from "@/components/tsl-card/index.vue";
import Charts from "@/components/dashboard/devops/audit/overview-chart";

import { reactive } from "vue";

export default {
  name: "audit-overview",
  components: {
    [Card.name]: Card,
    [Charts.name]: Charts
  },
  setup() {
    const cardIntroduce = reactive([
      {
        name: "introduce",
        title: "服务介绍"
      }
    ]);

    return {
      cardIntroduce
    };
  }
};
</script>

<style lang="less" scoped>
.card-container {
  height: 181px;
}
.content {
  color: #4e5969;
  font-weight: 400;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 20px;
  text-align: left;
}
</style>
